import Button from "@/components/button/Button";
import React from "react";
const SubmitOrCancelButtons = ({
  cancelText = "Cancel",
  disabled = false,
  onCancel,
  submitText = "Save"
}) => /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-end my-8" }, /* @__PURE__ */ React.createElement("div", { className: "flex gap-4 md:max-w-xs w-full" }, /* @__PURE__ */ React.createElement(Button, { color: "outline", onClick: onCancel, type: "button" }, cancelText), /* @__PURE__ */ React.createElement(Button, { color: "secondary", fullWidth: true, type: "submit", isDisabled: disabled }, submitText)));
export default SubmitOrCancelButtons;
